import React, { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import SelectedProfileCard from "../../../components/generic/cards/SelectedProfileCard";
import SearchAndSelect from "../../../components/generic/search/SearchAndSelect";
import { useReadMemory } from "../../generic/hooks/useReadMemory";
import MemoryType from "../../../service/memory/enum/MemoryType";
import { currentConfiguration } from "../../../service/memory/recoil/configurationstore";
import ConfigurationConstants from "../../utils/configurationconstants";
import { executeIntent } from "../../utils/IntentExecutor";
import IntentType from "../../../intentexecutor/utils/IntentType";
import { getFullName } from "../../careprovider/visits/utils";

const SelectWorkforce = ({ workforceName, setWorkforceName, showCancel, workforceList, label }) => {
  const userJson = useReadMemory(MemoryType.USER);
  const configuration = useRecoilValue(currentConfiguration);
  const secretKey =
    configuration[ConfigurationConstants.NIRAMAYA_ORGANIZATION_SECRETKEY];
  const [showDefaultPatientName, setShowDefaultPatientName] = useState(
    workforceName ? true : false
  );

  const fetchUserList = async (username) => {
    const searchPayload = {
      query: username,
      organizationIdentifier: userJson?.organizationIdentifier,
      secretKey: secretKey?.key,
      filters: {
        status: ["Onboarded"],
        workforceStatus: ["Active"]
      },
    };

    const responseData = await executeIntent(
      IntentType.SEARCH_WORKFORCE,
      searchPayload
    );
    const data = workforceList?.length ? workforceList : responseData?.workforceList
    const result = data.map((user) => ({
      label: getFullName(user?.givenName, user?.familyName),
      value: JSON.stringify(user),
      misc: user?.email && `Email: ${user.email}`,
    }));
    return result;
  };

  const handleUnselectItems = () => {
    setShowDefaultPatientName(false);
    setWorkforceName([]);
  };

  useEffect(() => {
    if (workforceName.length === 0) setShowDefaultPatientName(false);
    else setShowDefaultPatientName(true);
  }, [workforceName]);

  useEffect(() => {
    if (typeof workforceName?.label === "object") {
      setWorkforceName({
        label: workforceName?.label?.props?.children?.props?.title,
        value: workforceName?.value,
        misc: workforceName?.label?.props?.children?.props?.description,
      });
      setShowDefaultPatientName(true);
    }
  }, [workforceName]);

  return (
    <div className="section-one px-0">
      <span className="section-one-header required-mark-label">{label}</span>
      {showDefaultPatientName ? (
        <SelectedProfileCard
          selectedItems={workforceName}
          handleUnselectItems={handleUnselectItems}
          showCancel={showCancel}
        />
      ) : (
        <SearchAndSelect
          showSearch
          selectedValues={workforceName}
          placeholder="Search Volunteer"
          fetchOptions={fetchUserList}
          setValue={setWorkforceName}
          style={{
            width: "100%",
          }}
          selectOptionType="Info"
        />
      )}
    </div>
  );
};

export default SelectWorkforce;
